import type {
  PreActivationAccountResponseState,
  ShippingAccountState,
} from "./ShippingAccount.types";
import type { DutiesAndTaxesState } from "./DutiesAndTaxes";
import type { FaqsState } from "./FAQCard.types";
import type {
  CarrierRegistrationState,
  PutCarrierRegistrationState,
} from "./CarrierRegistration.types";
import type { BaseState } from "./Common.types";

export interface AccountState extends BaseState {
  shippingAccountsState: ShippingAccountState;
  dutiesAndTaxesState: DutiesAndTaxesState;
  carrierRegistrationsState: CarrierRegistrationState;
  putCarrierRegistrationState: PutCarrierRegistrationState;
  faqsState: FaqsState;
  preActivationAccountState: PreActivationAccountResponseState;
}
export const initialState: AccountState = {
  shippingAccountsState: {
    data: null,
    status: "idle",
    error: null,
  },
  dutiesAndTaxesState: {
    data: null,
    status: "idle",
    error: null,
  },
  carrierRegistrationsState: {
    data: null,
    status: "idle",
    error: null,
  },
  putCarrierRegistrationState: {
    data: null,
    status: "idle",
    error: null,
  },
  faqsState: {
    data: null,
    status: "idle",
    error: null,
  },
  preActivationAccountState: {
    data: null,
    status: "idle",
    error: null,
  },
  status: "idle",
  error: null,
};
